import section from "../../assets/images/5ttc.png";
import headerImage4 from "../../assets/images/image 10.png";
import headerImage2 from "../../assets/images/image 8.png";
import headerImage3 from "../../assets/images/image 9.png";
import headerImage1 from "../../assets/images/notion.png";
import headerImage5 from "../../assets/images/Subtract.png";

import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store";
import { fbAuth } from "../shared/firebase";

const provider = new GoogleAuthProvider();

function Index() {
  const navigate = useNavigate();
  const setAuthState = useAuthStore((state) => state.setAuthState);
  const setLoading = useAuthStore((state) => state.setLoading);
  const loading = useAuthStore((state) => state.loading);

  const login = async () => {
    try {
      setLoading(true);
      const result = await signInWithPopup(fbAuth, provider);
      if (!result?.user) {
        setLoading(false);
        return;
      }

      const user = result.user,
        token = await fbAuth.currentUser.getIdToken();

      setAuthState({
        token,
        user: {
          id: user.uid,
          email: user.email,
          name: user.displayName,
        },
      });

      setLoading(false);
      navigate("/integrations");
    } catch (err) {
      setLoading(false);
      const error = err as any;
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(errorCode, errorMessage);
    }
  };
  if (loading) {
    return (
      <div className="bg-gray-50 font-satoshi h-screen w-screen flex justify-center items-center">
        <div className="text-center text-2xl text-gray-500">
          <div className="border-r-4 rounded-full w-20 h-20 border-primary animate-spin mx-auto mb-5" />
          Please wait while we log you in
        </div>
      </div>
    );
  }
  return (
    <div className=" bg-gray-50 font-satoshi">
      <div className="container min-h-screen px-4 py-6 mx-auto font-inter">
        <nav className="flex items-center justify-between ">
          <h1 className="text-xl font-medium text-primary">Content0</h1>

          <div className="flex items-center space-x-4 ">
            <button
              type="button"
              onClick={login}
              className="px-5 py-3 text-sm transition-colors duration-200 rounded-full text-primary hover:bg-primary/10 bg-primary/5"
            >
              Sign Up
            </button>
            <button
              type="button"
              onClick={login}
              className="px-5 py-3 text-sm transition-colors duration-200 rounded-full text-primary hover:bg-primary/10 bg-primary/5"
            >
              Sign In
            </button>
          </div>
        </nav>

        <header className="py-20">
          <h1 className="max-w-4xl text-3xl font-semibold leading-normal tracking-wide lg:leading-normal lg:text-5xl">
            <span className=" text-primary">Content0</span> is developer
            friendly API over your existing content in your favourite content
            platform like Notion, AirTable & many more.
          </h1>

          <div className="flex flex-col items-center mt-8 sm:flex-row sm:space-x-8 ">
            <button
              className="order-2 w-full px-6 py-3 mt-6 font-medium text-center text-white transition-colors duration-200 rounded-full sm:order-1 sm:w-auto sm:mt-0 bg-primary hover:bg-primary/80"
              onClick={login}
            >
              Get Started
            </button>
            <div className="flex items-center order-1 space-x-8 sm:order-2">
              <img src={headerImage1} alt="" />
              <img src={headerImage5} alt="" />
              <img src={headerImage4} alt="" />
              <img src={headerImage2} alt="" />
              <img src={headerImage3} alt="" />
            </div>
          </div>
        </header>

        <section className="pb-20">
          <h3 className="text-lg font-light text-gray-700">
            What Does Content0 Do?
          </h3>

          <div className="grid grid-cols-1 gap-12 mt-16 md:grid-cols-2 xl:grid-cols-3">
            <div className="flex flex-col items-start">
              <svg
                className="h-12"
                viewBox="0 0 73 71"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M72.4162 43.7525C72.4162 43.7525 72.335 43.7525 72.4162 43.7525C72.335 43.6701 72.335 43.6701 72.2538 43.6701L65.6779 40.4597C65.6779 29.0997 59.5891 18.8099 49.6846 13.5415V7.2029C49.6846 6.70899 49.4411 6.21507 48.954 5.8858H48.8728C48.8728 5.8858 48.8728 5.8858 48.7916 5.80348L37.2635 0.123478C36.8575 -0.0411594 36.3704 -0.0411594 35.9645 0.123478L24.3552 5.72116C24.274 5.72116 24.274 5.80348 24.274 5.80348C24.274 5.80348 24.274 5.80348 24.1928 5.80348C23.7869 6.05044 23.4622 6.54435 23.4622 7.12058V12.389C12.5835 17.2458 5.52051 28.0296 5.43933 40.1304L0.893024 42.353C0.893024 42.353 0.81184 42.353 0.81184 42.4354H0.730656C0.324736 42.6823 0 43.1762 0 43.7525V56.4296C0 57.0058 0.324736 57.4997 0.81184 57.829L12.4212 63.509C12.6647 63.5913 12.8271 63.6736 13.0706 63.6736C13.3142 63.6736 13.4765 63.5913 13.7201 63.509L15.019 62.8504C20.6207 68.1188 27.7649 71 35.4774 71C42.8652 71 50.0094 68.2012 55.5299 63.262C55.6111 63.1797 55.6111 63.0974 55.6922 63.0974L59.2643 64.8261C59.5079 64.9084 59.6703 64.9907 59.9138 64.9907C60.1574 64.9907 60.3197 64.9084 60.5633 64.8261L72.1726 59.1461C72.6597 58.8991 72.9844 58.4052 72.9844 57.7467V44.9872C73.0656 44.4933 72.8221 43.9994 72.4162 43.7525ZM58.4525 60.9571L49.847 56.7588V47.3745L58.4525 51.5728V60.9571ZM59.995 49.0209L51.7954 45.0696L59.995 41.1183L68.1946 45.0696L59.995 49.0209ZM26.466 9.50783L35.0715 13.7061V23.0081L26.466 18.8099V9.50783ZM38.0753 13.7061L46.6808 9.50783V18.8099L38.0753 23.0081V13.7061ZM36.614 3.16928L44.8136 7.12058L36.614 11.0719L28.4144 7.12058L36.614 3.16928ZM13.1518 39.7188L21.3514 43.6701L13.1518 47.7038L5.03341 43.6701L13.1518 39.7188ZM14.6943 59.64V50.338L23.2998 46.0574V55.3594L14.6943 59.64ZM3.08499 46.0574L11.6905 50.2556V59.5577L3.08499 55.4417V46.0574ZM35.5586 67.8719C29.0639 67.8719 22.8939 65.567 18.0229 61.2864L25.4918 57.6643C25.9789 57.4174 26.3036 56.9235 26.3036 56.2649V43.6701C26.3036 43.1762 26.0601 42.6823 25.573 42.353C25.573 42.353 25.4918 42.353 25.4918 42.2707C25.4918 42.2707 25.4918 42.2707 25.4106 42.2707L13.8013 36.5907C13.3954 36.4261 12.9083 36.4261 12.5023 36.5907L8.44314 38.5664C9.09261 28.7704 14.7755 20.0446 23.4622 15.6817V19.7154C23.4622 20.2916 23.7869 20.7855 24.274 21.1148L35.8833 26.7948C36.1269 26.8771 36.2893 26.9594 36.5328 26.9594C36.7764 26.9594 36.9387 26.8771 37.1823 26.7948L48.7916 21.1148C49.2787 20.8678 49.6034 20.3739 49.6034 19.7154V16.8342C57.2347 21.5264 62.1058 29.7583 62.5117 38.8133L60.5633 37.8255C60.1574 37.6609 59.6703 37.6609 59.2643 37.8255L47.655 43.5055C47.655 43.5055 47.655 43.5055 47.5738 43.5878C47.5738 43.5878 47.4927 43.5878 47.4927 43.6701C47.0867 43.9171 46.762 44.411 46.762 44.9872V57.6643C46.762 58.2406 47.0867 58.7345 47.5738 59.0638L52.6884 61.5333C47.9798 65.6493 41.891 67.8719 35.5586 67.8719ZM70.0618 56.7588L61.4563 60.9571V51.6551L70.0618 47.4568V56.7588Z"
                  fill="#FF6E30"
                />
              </svg>

              <h2 className="mt-6 text-2xl font-semibold leading-relaxed text-gray-800">
                Static Resources are Auto uploaded to CDN For Faster Delivery of
                content.
              </h2>

              <p className="mt-2 font-light text-gray-600">
                CloudFlare or your preferred CDN
              </p>
            </div>

            <div className="flex flex-col items-start">
              <svg
                className="h-12 "
                viewBox="0 0 82 61"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M79.0268 27.8525H71.1975V2.50623C71.1975 1.11949 70.0789 0 68.6934 0H2.50406C1.11852 0 0 1.11955 0 2.50623V49.3047C0 50.6914 1.11858 51.8109 2.50406 51.8109H33.0859V55.9712H25.0732C23.6876 55.9712 22.5691 57.0907 22.5691 58.4774C22.5691 59.8641 23.6877 60.9836 25.0732 60.9836H46.1072C47.4927 60.9836 48.6112 59.8641 48.6112 58.4774C48.6112 57.0906 47.4926 55.9712 46.1072 55.9712H38.0944V51.8109H60.3794V58.9118C60.3794 60.0649 61.3145 61 62.4658 61H79.0086C80.1608 61 81.095 60.0641 81.095 58.9118L81.0958 29.9395C81.1122 28.7864 80.1778 27.8513 79.0258 27.8513L79.0268 27.8525ZM66.1894 5.01225V27.8525H62.4832C61.331 27.8525 60.3967 28.7884 60.3967 29.9407V38.4618H5.00812V5.01145L66.1894 5.01225ZM5.00772 46.7987V42.6384H60.3804V46.7987H5.00772ZM76.9402 56.8238H64.5704V32.0295H76.9402V56.8238Z"
                  fill="#FF6E30"
                />
              </svg>

              <h2 className="mt-6 text-2xl font-semibold leading-relaxed text-gray-800">
                Content is Delivered for best viewing experience For All
                Devices.
              </h2>

              <p className="mt-2 font-light text-gray-600">
                Content can be restyled, default formatting available.{" "}
              </p>
            </div>

            <div className="flex flex-col items-start">
              <svg
                className="h-12"
                viewBox="0 0 73 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M49.666 43L69.666 23L49.666 3"
                  stroke="#FF6E30"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M23 3L3 23L23 43"
                  stroke="#FF6E30"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <h2 className="mt-6 text-2xl font-semibold leading-relaxed text-gray-800">
                Different types of API available over the same content Platform.
              </h2>

              <p className="mt-2 font-light text-gray-600">
                Ability to write back new properties to you CMS
              </p>
            </div>
          </div>
        </section>

        <section className="pb-20">
          <h3 className="text-lg font-light text-gray-700">
            Comparing to Traditional CMS
          </h3>

          <div className="flex flex-col mt-16">
            <div className="-my-2 overflow-x-auto xl:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <div className="overflow-hidden rounded-lg">
                  <table className="min-w-full">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="px-8 py-6 pr-16 text-lg font-medium text-left text-gray-700 capitalize bg-gray-100 w-96 whitespace-nowrap"
                        >
                          Feature
                        </th>

                        <th
                          scope="col"
                          className="px-8 py-6 pr-16 text-lg font-medium text-left capitalize bg-primary/5 text-primary whitespace-nowrap"
                        >
                          Content0
                        </th>

                        <th
                          scope="col"
                          className="px-8 py-6 pr-16 text-lg font-medium text-left text-gray-700 capitalize bg-primary/5 whitespace-nowrap"
                        >
                          other Headless CMS
                        </th>
                      </tr>
                    </thead>

                    <tbody className="bg-white divide-y divide-gray-100">
                      <tr>
                        <td className="px-8 py-6 font-medium text-gray-700 capitalize bg-gray-100 whitespace-nowrap">
                          Editor
                        </td>

                        <td className="px-8 py-6 font-medium text-gray-700 capitalize whitespace-nowrap">
                          Use your fav editor
                        </td>

                        <td className="px-8 py-6 font-medium text-gray-700 capitalize whitespace-nowrap">
                          Proprietary or Markdown
                        </td>
                      </tr>

                      <tr>
                        <td className="px-8 py-6 font-medium text-gray-700 capitalize bg-gray-100 whitespace-nowrap">
                          API
                        </td>

                        <td className="px-8 py-6 font-medium text-gray-700 capitalize whitespace-nowrap">
                          Block API
                        </td>

                        <td className="px-8 py-6 font-medium text-gray-700 capitalize whitespace-nowrap">
                          Resource, Post, GraphQL, Rest
                        </td>
                      </tr>

                      <tr>
                        <td className="px-8 py-6 font-medium text-gray-700 capitalize bg-gray-100 whitespace-nowrap">
                          Costing
                        </td>

                        <td className="px-8 py-6 whitespace-nowrap">
                          <div>
                            <p className="font-medium text-gray-700 capitalize">
                              Charged by Usage
                            </p>
                            <p className="text-sm font-light ">
                              Application based - Blog, Marketing, E-commerce or
                              Generic
                            </p>
                          </div>
                        </td>

                        <td className="px-8 py-6 font-medium text-gray-700 capitalize whitespace-nowrap">
                          Charged by per block store*
                        </td>
                      </tr>

                      <tr>
                        <td className="px-8 py-6 font-medium text-gray-700 capitalize bg-gray-100 whitespace-nowrap">
                          Content organization
                        </td>

                        <td className="px-8 py-6 font-medium text-gray-700 capitalize whitespace-nowrap">
                          Keep your current organization
                        </td>

                        <td className="px-8 py-6 font-medium text-gray-700 capitalize whitespace-nowrap">
                          Reorganize based on CMS
                        </td>
                      </tr>

                      <tr>
                        <td className="px-8 py-6 font-medium text-gray-700 capitalize bg-gray-100 whitespace-nowrap">
                          CDN
                        </td>

                        <td className="px-8 py-6 whitespace-nowrap">
                          <div>
                            <p className="font-medium text-gray-700 capitalize">
                              Provides CloudFlare by default
                            </p>
                            <p className="text-sm font-light ">
                              You can add your own CDN
                            </p>
                          </div>
                        </td>

                        <td className="px-8 py-6 font-medium text-gray-700 capitalize whitespace-nowrap">
                          Proprietary
                        </td>
                      </tr>

                      <tr>
                        <td className="px-8 py-6 font-medium text-gray-700 capitalize bg-gray-100 whitespace-nowrap">
                          Write Back
                        </td>

                        <td className="px-8 py-6 font-medium text-gray-700 capitalize whitespace-nowrap">
                          Unlimited
                        </td>

                        <td className="px-8 py-6 font-medium text-gray-700 capitalize whitespace-nowrap">
                          Limited
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20">
          <h3 className="text-lg font-light text-gray-700">
            Example Implementation of Content site using Notion
          </h3>

          <div className="mt-16 lg:flex lg:items-center lg:space-x-16 ">
            <div className="w-full lg:w-1/3">
              <h3 className="text-base font-medium text-primary">Objective</h3>
              <h1 className="mt-4 text-3xl font-semibold capitalize">
                Publish a Content <br /> website For 5ttc.
              </h1>
              <p className="mt-4 font-light text-gray-500">
                See How 5ttc made it work
              </p>

              <div className="flow-root mt-6">
                <ul className="-mb-8">
                  <li>
                    <div className="relative pb-8">
                      <span
                        className="absolute top-[1.6rem] left-2.5 -ml-px h-10 w-0.5 bg-primary"
                        aria-hidden="true"
                      ></span>

                      <div className="relative flex items-center">
                        <div>
                          <span className="flex items-center justify-center w-5 h-5  rounded-full ring-1 ring-primary">
                            <span className="w-3 h-3 rounded-full bg-primary"></span>
                          </span>
                        </div>

                        <div className="min-w-0 flex-1 pt-1.5 mx-3">
                          <p className="text-gray-800 capitalize">
                            5ttc Team Started by creating a new database
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="relative pb-8 -mt-0.5">
                      <span
                        className="absolute top-[1.6rem] left-2.5 -ml-px h-10 w-0.5 bg-primary"
                        aria-hidden="true"
                      ></span>

                      <div className="relative flex items-center">
                        <div>
                          <span className="flex items-center justify-center w-5 h-5  rounded-full ring-1 ring-primary">
                            <span className="w-3 h-3 rounded-full bg-primary"></span>
                          </span>
                        </div>

                        <div className="min-w-0 flex-1 pt-1.5 mx-3">
                          <p className="text-gray-800 capitalize">
                            Created a new Page
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="relative pb-8 -mt-0.5">
                      <span
                        className="absolute top-[1.6rem] left-2.5 -ml-px h-10 w-0.5 bg-primary"
                        aria-hidden="true"
                      ></span>

                      <div className="relative flex items-center">
                        <div>
                          <span className="flex items-center justify-center w-5 h-5  rounded-full ring-1 ring-primary">
                            <span className="w-3 h-3 rounded-full bg-primary"></span>
                          </span>
                        </div>

                        <div className="min-w-0 flex-1 pt-1.5 mx-3">
                          <p className="text-gray-800 capitalize">
                            Added the content
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="relative pb-8 -mt-0.5">
                      <div className="relative flex items-center">
                        <div>
                          <span className="flex items-center justify-center w-5 h-5  rounded-full ring-1 ring-primary">
                            <span className="w-3 h-3 rounded-full bg-primary"></span>
                          </span>
                        </div>

                        <div className="min-w-0 flex-1 pt-1.5 mx-3">
                          <p className="text-gray-800 capitalize">
                            Connected with Content0
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex-1 mt-8 lg:mt-0 ">
              <img className="mx-auto " src={section} alt="" />
            </div>
          </div>
        </section>
      </div>

      <footer className=" bg-[#222930]">
        <div className="container px-4 py-10 mx-auto md:flex md:items-center md:justify-between">
          <div>
            <h3 className="text-2xl font-medium text-primary">Content0</h3>
            <p className="max-w-md mt-4 text-base text-gray-400 lg:max-w-full">
              bring Headless CMS to your content instead of taking content to
              Headless CMS
            </p>
            <p className="white">Powered by Azodha Platform. For more details <a href="https://azodha.com">Azodha</a></p>
          </div>

          <button
            className="inline-block px-12 py-3 mt-6 font-medium text-white transition-colors duration-200 rounded-full bg-primary hover:bg-primary/80"
            onClick={login}
          >
            Get Started
          </button>
        </div>
      </footer>
    </div>
  );
}

export default Index;
